import EventTarget from '../data/EventTarget';

export default class BarEventTarget extends EventTarget {
	constructor(params) {
		super(params);
		this.x = params.x;
	}
}
